import countries from "utils/static/countries";

import {
    getList as _getList,
    getAll as _getAll,
    add as _add,
    update as _update,
    getOneById as _getOneById,
    deleteAll as _deleteAll,
    getListAsync as _getListAsync,
} from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/management/clients";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "firstName",
    orderDirection: "asc",
    pageNumber: 0,
    pageSize: 5,
};

export function normalizeCustomerData(data) {
    const { birthDate: birthDateInMillis, country: countryCode } = data;

    const birthDate = new Date(birthDateInMillis);
    const country = countryCode ? countries.find((x) => x.code === countryCode) : null;

    return {
        ...data,
        birthDate,
        birthDateString: dateToString(birthDate, false),
        country,
    };
}

function normalizeData(data) {
    return data.map((d) => normalizeCustomerData(d));
}

export function getAll({ onSuccess, onError }) {
    _getAll({ url: BASE_URL, onSuccess, onError, normalizer: normalizeData });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export async function getListAsync(data = DEFAULT_LIST_DATA) {
    return _getListAsync({ url: BASE_URL, data, normalizer: normalizeData });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeCustomerData,
    });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export function getResources({ onSuccess, onError }) {
    const resources = {
        countries,
        cities: [],
        states: [],
    };

    onSuccess(resources);
}

export function getForms({ id, onSuccess, onError }) {
    _getAll({ url: `${BASE_URL}/${id}/forms`, onSuccess, onError });
}
